module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8VVmP"))).then(() => parcelRequire('f4eak'));